import { useEffect, useState } from 'react';

/**
 * Only show a loader after `delayMs` of continuous loading — skips flash on fast transitions.
 */
export function useDeferredLoader(isLoading, { delayMs = 380, enabled = true } = {}) {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (!enabled || !isLoading) {
      setShowLoader(false);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setShowLoader(true);
    }, delayMs);

    return () => {
      window.clearTimeout(timer);
      setShowLoader(false);
    };
  }, [isLoading, delayMs, enabled]);

  return showLoader;
}

export default useDeferredLoader;
